'use client';

import styled from 'styled-components';

import type { SpacingType} from '@zoomit/primitives';
import { spacingHelper, Breakpoints, ContainerMaxWidth } from '@zoomit/primitives';

type Props = {
  spacing?: SpacingType;
};

export const Container = styled.div<Props>`
  ${({ spacing }) => spacing && spacingHelper(spacing)};
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: ${Breakpoints.sm}) {
    & {
      max-width: ${ContainerMaxWidth.sm};
    }
  }
  @media (min-width: ${Breakpoints.md}) {
    & {
      max-width: 100%;
      padding-right: 4.8rem;
      padding-left: 4.8rem;
    }
  }
  @media (min-width: ${Breakpoints.xxl}) {
    & {
      max-width: ${ContainerMaxWidth.xl};
      padding: 0;
    }
  }
`;
